import { render, staticRenderFns } from "./PackFromFiles.vue?vue&type=template&id=22c8a799&"
import script from "./PackFromFiles.vue?vue&type=script&lang=js&"
export * from "./PackFromFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports